import { put, takeEvery } from 'redux-saga/effects'
import { AxiosResponse } from 'axios'

import { BuyerActions } from 'primsell-shared-layer/features'
import { BuyerAPI } from 'primsell-shared-layer/api'
import { IResponse, IResponseGetBuyerData } from 'primsell-shared-layer/types'

export function* getBuyerDataSaga(action: ReturnType<typeof BuyerActions.getBuyerDataRequest>): Generator {
  try {
    const { address } = action.payload

    const {
      data: { data },
    } = (yield BuyerAPI.getBuyersData()) as AxiosResponse<IResponse<IResponseGetBuyerData>>
    yield put(
      BuyerActions.getBuyerDataSuccess({
        address,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
      })
    )
  } catch (error) {
    yield put(BuyerActions.getBuyerDataFailed((error as Error)?.message))
  }
}

function* buyerSagas(): Generator {
  yield takeEvery(BuyerActions.getBuyerDataRequest, getBuyerDataSaga)
}

export { buyerSagas }
